<div *transloco="let t; read: 'profile-list-header'"
  class="main-header"
  [class.ghost]="isInitialLoad()">
  <div class="content">
    <div class="header-wrapper">
      <div>
        <h1 class="mat-h1">
          {{ name() || t('credential_holder_directory') }}
        </h1>

        <div class="issuers-members">
          <div class="members-count">
            <mat-icon class="trailing-margin icon-group"/>
            {{ totalProfiles() ? t('directory_members', { count: totalProfiles() }) : '' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
